// Display-only helpers for text that comes from the API

// Titles come from the API in ALL CAPS; show them in Title Case like the
// other page headings ("of", "the", "and"... stay lowercase)
const SMALL_WORDS = ["a", "an", "and", "at", "by", "for", "in", "of", "on", "or", "the", "to"];

export const toTitleCase = (text = "") => {
  if (!text || text !== text.toUpperCase()) return text;
  return text
    .toLowerCase()
    .split(" ")
    .map((w, i, arr) =>
      i > 0 && SMALL_WORDS.includes(w) && !arr[i - 1].endsWith(":")
        ? w
        : w.charAt(0).toUpperCase() + w.slice(1),
    )
    .join(" ");
};
